import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Box } from "@mui/material";

import useEntity from "../../hooks/useEntity";
import useData from "../../hooks/useData";
import useLocalization from "../../hooks/useLocalization";

import Page from "./Page";
import BannersTable from "../ui/BannersTable";
import Card from "../layout/Card";
import RetailerEditor from "../editors/RetailerEditor";

const Retailer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setEntity, getEntityData, entityData, updateField, saved } =
    useEntity();
  const { getFromServer, updateRecord, deleteRecord } = useData();
  const { getTitle } = useLocalization();

  const [retailerId, setRetailerId] = useState(null);
  const [banners, setBanners] = useState([]);
  const [includeInactiveBanners, setIncludeInactiveBanners] = useState(false);

  useEffect(() => {
    setEntity("Retailer");
    setRetailerId(location.state.retailerId);
  }, []);

  useEffect(() => {
    getData();
  }, [retailerId]);

  useEffect(() => {
    getData();
  }, [includeInactiveBanners]);

  const getData = async () => {
    if (!retailerId) return;

    getEntityData(retailerId);
    const bannerData = await getFromServer({
      entityName: "Banner",
      filter: {
        retailerId: retailerId,
        includeInactive: includeInactiveBanners,
      },
    });
    if (bannerData) {
      setBanners(bannerData);
    } else {
      setBanners([]);
    }
  };

  useEffect(() => {
    if (!saved) return;
    getData();
  }, [saved]);

  const handleToolbarClick = (name) => {
    switch (name) {
      case "back":
        navigate("/retailers");
        break;
      case "refresh":
        getData();
        break;
    }
  };

  const handleSaveRetailerInfo = async () => {
    await getData();
  };

  const handleBannerClick = (bannerId) => {
    navigate("/banner", {
      state: {
        bannerId,
        retailerId,
      },
    });
  };

  const handleAddBanner = () => {
    navigate("/banner", {
      state: {
        bannerId: null,
        retailerId,
      },
    });
  };

  if (!entityData) return null;

  return (
    <Page
      pageName={entityData.name}
      includeToolbar
      items={[
        { name: "back", iconName: "ArrowBack" },
        { name: "refresh", iconName: "Refresh" },
      ]}
      onToolItemClick={handleToolbarClick}
    >
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
      >
        <Card title="Retailer Information">
          <RetailerEditor
            retailerId={retailerId}
            onSave={handleSaveRetailerInfo}
          />
        </Card>

        <Card title="Banners">
          <BannersTable
            banners={banners}
            onBannerClick={handleBannerClick}
            onAddBanner={handleAddBanner}
            includeInactive={includeInactiveBanners}
            onIncludeInactiveChange={setIncludeInactiveBanners}
          />
        </Card>
      </Box>
    </Page>
  );
};

export default Retailer;
